"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var react_1 = __importDefault(require("react"));
var ChevronUpIcon_1 = __importDefault(require("mdi-react/ChevronUpIcon"));
var ChevronDownIcon_1 = __importDefault(require("mdi-react/ChevronDownIcon"));
var PlusIcon_1 = __importDefault(require("mdi-react/PlusIcon"));
var MinusIcon_1 = __importDefault(require("mdi-react/MinusIcon"));
var material_1 = require("@mui/material");
var TableObject_1 = require("../../../TableObject");
var RowActionButtons = function (_a) {
    var currentTableObj = _a.currentTableObj, rowIndex = _a.rowIndex, rowsCount = _a.rowsCount, t = _a.t;
    var onRowClick = function (rowActionType) { return function () {
        if (currentTableObj) {
            switch (rowActionType) {
                case TableObject_1.RowActionType.addRowBelow:
                    {
                        currentTableObj.rowAction(TableObject_1.RowActionType.addRowBelow, rowIndex);
                    }
                    break;
                case TableObject_1.RowActionType.deleteRow:
                    {
                        currentTableObj.rowAction(TableObject_1.RowActionType.deleteRow, rowIndex);
                    }
                    break;
                case TableObject_1.RowActionType.moveRowUp:
                    {
                        currentTableObj.rowAction(TableObject_1.RowActionType.moveRowUp, rowIndex);
                    }
                    break;
                case TableObject_1.RowActionType.moveRowDown:
                    {
                        currentTableObj.rowAction(TableObject_1.RowActionType.moveRowDown, rowIndex);
                    }
                    break;
            }
        }
    }; };
    return (react_1.default.createElement(material_1.ButtonGroup, { id: 'row-action-buttons', size: 'small', color: 'inherit', variant: 'outlined', style: {
            maxHeight: '22px',
            backgroundColor: '#fafafa',
            color: 'black',
            left: '101%',
            top: 0,
            position: 'absolute',
            boxShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        } },
        react_1.default.createElement(Tooltip_1.default, { disableInteractive: true, title: t('contents.widgets.table.addRowBelow') },
            react_1.default.createElement(material_1.Button, { onClick: onRowClick(TableObject_1.RowActionType.addRowBelow), tabIndex: -1 },
                react_1.default.createElement(PlusIcon_1.default, { size: '18px' }))),
        react_1.default.createElement(Tooltip_1.default, { disableInteractive: true, title: t('contents.widgets.table.deleteDataRow') },
            react_1.default.createElement(material_1.Button, { onClick: onRowClick(TableObject_1.RowActionType.deleteRow), tabIndex: -1 },
                react_1.default.createElement(MinusIcon_1.default, { size: '18px' }))),
        rowIndex < rowsCount - 1 && (react_1.default.createElement(Tooltip_1.default, { disableInteractive: true, title: t('contents.widgets.table.moveDataRowDown') },
            react_1.default.createElement(material_1.Button, { onClick: onRowClick(TableObject_1.RowActionType.moveRowDown), tabIndex: -1 },
                react_1.default.createElement(ChevronDownIcon_1.default, { size: '18px' })))),
        rowIndex > 0 && (react_1.default.createElement(Tooltip_1.default, { disableInteractive: true, title: t('contents.widgets.table.moveDataRowUp') },
            react_1.default.createElement(material_1.Button, { onClick: onRowClick(TableObject_1.RowActionType.moveRowUp), tabIndex: -1 },
                react_1.default.createElement(ChevronUpIcon_1.default, { size: '18px' }))))));
};
exports.default = RowActionButtons;
//# sourceMappingURL=RowActionButtons.js.map